import TickCircle from '@r1-frontend/ui-react/components/svg/main/TickCircle';

import * as ST from './styled';

interface IProps {
    benefits: string,
}

const SubscriptionBenefitsTextBlock = ({ benefits }: IProps): JSX.Element => {
    return <ST.BenefitsText>
        <TickCircle size={20} />
        <ST.TextValue dangerouslySetInnerHTML={{ __html: benefits }}/>
        </ST.BenefitsText>;
};

export default SubscriptionBenefitsTextBlock;
